/**
 * @what intercepts log.user requests and sends them to a user-notification
 * @why easy notifications to the user
 */
angular.module('utility-ng-configuration').provider('NotificationConfiguration', function NotificationConfigurationProvider() {

  var DEFAULTS = {
    notificationHandle: 'user-notification',
    notificationChannels: ['info', 'success', 'warn', 'error']
  };

  this.$get = function (log, phxNotificationDelegate) {

    var configuration = _.merge({}, DEFAULTS);

    return {
      configure: function configure_NotificationConfiguration(userConfig) {
        if (!!userConfig) {
          configuration = _.merge({}, DEFAULTS, userConfig);
        }
        return configuration;
      },
      activate: function activate_NotificationConfiguration(userConfiguration) {

        var userNotificationDelegate;

        if (!!userConfiguration) {
          this.configure(userConfiguration);
        }

        userNotificationDelegate = phxNotificationDelegate.restrictTo(configuration.notificationHandle);

        _.each(configuration.notificationChannels, function (logChannel) {
          this.on(logChannel, function (event) {
            userNotificationDelegate[event.channel](event.message);
          });
        }, log.user);

      }
    };
  };

});



// WEBPACK FOOTER //
// notification_configuration.js